import { loginRequest, msalInstance } from './msalConfig'
import { hasAllPermissions, hasPermission, permissionNames } from './authorization'
import { ensurePermissionsAsync, getMsalState } from './msalPlugin'

function getRequiredPermissions (route) {
  return route.matched.flatMap((matchedRoute) => (
    matchedRoute.meta.requiredPermissions ?? []
  ))
}

function getAuthorizedHomeRoute () {
  if (hasPermission(permissionNames.eventsAccess)) {
    return { name: 'events-list' }
  }

  if (hasPermission(permissionNames.driveparkAccess)) {
    return { name: 'fleet-calendar' }
  }

  return null
}

// All routes require auth by default. To exempt a route (e.g. a future
// login-related page), set `meta: { public: true }` on it.
export function registerAuthGuard (router) {
  router.beforeEach(async (to) => {
    if (to.meta.public) {
      return true
    }

    if (msalInstance.getAllAccounts().length === 0) {
      // No account yet: send the user to the CIAM hosted sign-in page and
      // come back to the route they originally asked for.
      msalInstance.loginRedirect({
        ...loginRequest,
        redirectStartPage: to.fullPath,
      })

      return false
    }

    await ensurePermissionsAsync(getMsalState())

    if (to.name === 'forbidden') {
      const redirectPath = to.query.redirect

      if (typeof redirectPath === 'string') {
        const redirectRoute = router.resolve(redirectPath)

        if (
          redirectRoute.name !== 'forbidden' &&
          hasAllPermissions(getRequiredPermissions(redirectRoute))
        ) {
          return redirectPath
        }

        return true
      }

      return getAuthorizedHomeRoute() ?? true
    }

    const requiredPermissions = getRequiredPermissions(to)

    if (!hasAllPermissions(requiredPermissions)) {
      return {
        name: 'forbidden',
        query: { redirect: to.fullPath },
      }
    }

    return true
  })
}
